import React from 'react';
import PropTypes from 'prop-types';
import Times from '@alefeducation/ui-elements-library-icons/lib/components/Icons/Times';
import Unlock from '@alefeducation/ui-elements-library-icons/lib/components/Icons/Unlock';
import './styles/ncle-icons.scss';

export const UnassignAllIcon = ({ size = 18 }) => (
  <span
    className="ncle-unassign-icon"
    style={{ width: size, height: size }}
    aria-hidden
  >
    <span
      className="ncle-unassign-icon__dot"
      style={{ width: size, height: size }}
    />
    <span className="ncle-unassign-icon__overlay">
      <span
        className="ncle-unassign-icon__circle"
        style={{ width: size + 2, height: size + 2 }}
      >
        <Times fontSize={10} color="#ffffff" />
      </span>
    </span>
  </span>
);

UnassignAllIcon.propTypes = {
  size: PropTypes.number,
};

UnassignAllIcon.defaultProps = {
  size: 18,
};

export const renderUnassignIcon = isNCLE =>
  isNCLE ? <UnassignAllIcon size={18} /> : <Unlock fontSize={18} />;
